import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";

import ModalForm from "../../Create/ModalForm";

export default function Filters({ keyword, setKeyword }) {
  const [showCreateForm, setShowCreateForm] = useState(false);

  return (
    <div className="invite_search">
      <Row>
        <Col md={3}>
          <form
            className="inviteSearch_form manager-member-keyword"
            action="javascript:void(0);"
          >
            <input
              type="text"
              placeholder="Search Team"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>
        <Col md={9} className="text-right">
          <Button onClick={(e) => setShowCreateForm(true)} bsStyle="primary">
            Add Team
          </Button>
          <ModalForm
            showForm={showCreateForm}
            closeForm={() => setShowCreateForm(false)}
          />
        </Col>
      </Row>
    </div>
  );
}
